import { Component, OnInit } from '@angular/core';
import { MensagemService, ProgressoService, StringUtils } from 'maestro-ng';
import { ArquivoService } from '../../arquivo/arquivo.service';
import { downloadBlob } from '../../util/utils';

@Component({
  selector: 'app-arquivo-exportacao',
  templateUrl: './arquivo-exportacao.component.html',
  styleUrls: ['./arquivo-exportacao.component.css'],
})
export class ArquivoExportacaoComponent implements OnInit {
  public ids: string;
  public arquivo: Blob;

  constructor(
    private service: ArquivoService,
    private mensagemService: MensagemService,
    private progressoService: ProgressoService
  ) {}

  ngOnInit(): void {}

  public exportarTextos() {
    if (StringUtils.isUndefinedOrEmpty(this.ids)) {
      this.mensagemService.addAlerta('Alerta', 'Por favor digite algum id de arquivo para exportação!');
      return;
    }

    this.progressoService.modal();

    const listaIds = this.ids
      .replace(/\\n/, ' ')
      .split(',')
      .map((id) => parseInt(id.trim(), 10))
      .filter((item) => !isNaN(item));

    this.service
      .exportarTextosEmArquivoZip(listaIds)
      .then((result) => {
        this.progressoService.fechar();
        downloadBlob('arquivo-exportados.zip', result);
      })
      .catch((result) => {
        this.progressoService.fechar();
        this.mensagemService.addErro('Erro', result);
      });
  }

  private reiniciar(): void {
    this.ids = undefined;
    this.arquivo = undefined;
  }
}
